module.exports = __webpack_public_path__ + "static/media/Sanitarios.415a053e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/NoAvailable/Sanitarios.svg
// module id = 1822
// module chunks = 0